import { compose } from 'recompose';
import ClientForm from './clientForm';

const enhance = compose(

);

export default enhance(ClientForm);
